import { Position, Toaster } from "@blueprintjs/core";

/** Singleton toaster instance. Create separate instances for different options. */
export const CreationToaster = Toaster.create({
    className: "template-create-toaster",
    position: Position.BOTTOM_RIGHT
});

export const DeletionToaster = Toaster.create({
    className: "template-delete-toaster",
    position: Position.BOTTOM_RIGHT
});

export const RunToaster = Toaster.create({
    className: "template-run-toaster",
    position: Position.BOTTOM_RIGHT
});

export const ApprovalToaster = Toaster.create({
    className: "approval-toaster",
    position: Position.BOTTOM_RIGHT
});
